/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Simple_Door_Guided_P1Inputs */

const en_simple_door_guided_p1 = /** @type {(inputs: Simple_Door_Guided_P1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`15-minute review — ${i?.price}`)
};

const id_simple_door_guided_p1 = /** @type {(inputs: Simple_Door_Guided_P1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tinjau 15 menit — ${i?.price}`)
};

/**
* | output |
* | --- |
* | "15-minute review — {price}" |
*
* @param {Simple_Door_Guided_P1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_door_guided_p1 = /** @type {((inputs: Simple_Door_Guided_P1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Door_Guided_P1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_door_guided_p1(inputs)
	return en_simple_door_guided_p1(inputs)
});